export const ACHIEVEMENTS = [
  {
    title: "March 2023",
    items: [
      {
        title: "Incubated by CIBA Goa & NITK STEP",
        desc: `FlexiBus was selected for incubation by CIBA Goa and NITK STEP, providing mentorship, industry guidance, and support to accelerate product development and business growth.`
      },
    ]
  },
  {
    title: "July 2023",
    items: [
      {
        title: "Company Incorporated & Government Recognition",
        desc: `The company was officially incorporated and recognised by the IT & Startup Promotion Cell, Government of Goa, validating its vision and enabling access to the state's startup ecosystem.`
      },
    ]
  },
  {
    title: "September 2023",
    items: [
      {
        title: "Successful KTCL Goa Pilot",
        desc: `Successfully completed a pilot with Kadamba Transport Corporation Limited (KTCL), tracking 25 electric buses in real time and achieving over 500 app downloads during the pilot phase.`
      },
    ]
  },
  {
    title: "December 2023",
    items: [
      {
        title: "Built ERP Solution for BSRTC",
        desc: `Designed and developed an Enterprise Resource Planning (ERP) solution for the Bihar State Road Transport Corporation (BSRTC), streamlining operational workflows and transport management processes.`
      },
    ]
  },
];